// extracted by mini-css-extract-plugin
export default {"root":"buttonsGroup_root__acZgf","isProfile":"buttonsGroup_isProfile__gpi+S","isCentered":"buttonsGroup_isCentered__iCbPl","full":"buttonsGroup_full__KVWP2"};